/**
 * Environment configuration
 * All environment variables are accessed through this module
 */

export const env = {
  // App info
  appName: import.meta.env.VITE_APP_NAME || 'Baú da Gata',
  appUrl: import.meta.env.VITE_APP_URL || 'https://bau-da-gata.com',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Environment
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
  mode: import.meta.env.MODE,

  // Contact
  whatsappNumber: import.meta.env.VITE_WHATSAPP_NUMBER || '',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL || '',

  // Social Media
  instagramUrl: import.meta.env.VITE_INSTAGRAM_URL || '',
  tiktokUrl: import.meta.env.VITE_TIKTOK_URL || '',
  youtubeUrl: import.meta.env.VITE_YOUTUBE_URL || '',
  pinterestUrl: import.meta.env.VITE_PINTEREST_URL || '',

  // Analytics
  gaTrackingId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',

  // Sentry
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',

  // Feature flags
  enablePwa: import.meta.env.VITE_ENABLE_PWA !== 'false',
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS !== 'false'
};

/**
 * Validate required environment variables
 * @returns {string[]} Array of missing required variables
 */
export function validateEnv() {
  const required = ['VITE_WHATSAPP_NUMBER'];
  const missing = [];

  for (const key of required) {
    if (!import.meta.env[key]) {
      missing.push(key);
    }
  }

  return missing;
}

/**
 * Log environment info (only in development)
 */
export function logEnvInfo() {
  if (env.isDevelopment) {
    console.group('Environment Info');
    console.log('Mode:', env.mode);
    console.log('App:', env.appName);
    console.log('WhatsApp configured:', !!env.whatsappNumber);
    console.log('Analytics configured:', !!env.gaTrackingId);
    console.log('Sentry configured:', !!env.sentryDsn);
    console.groupEnd();
  }
}
